import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { EstateClientRow } from "routes/system-admin/sso-overview/estate-client-row"
import { NoEstateResults } from "routes/system-admin/sso-overview/no-estate-results"

export function EstateClientTable({ clients = [] }) {
    return (
        <TableContainer sx={{ mb: 4 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                {`Clients (${clients.length})`}
            </Typography>
            <Table size="small" data-cy="sso-estate-client-table">
                <TableHead>
                    <TableRow>
                        <TableCell>Client</TableCell>
                        <TableCell>Provider</TableCell>
                        <TableCell>SSO</TableCell>
                        <TableCell>SCIM</TableCell>
                        <TableCell>Tokens</TableCell>
                        <TableCell>Breaker</TableCell>
                        <TableCell align="right">Parked</TableCell>
                        <TableCell align="right">Settings</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Repeat
                        list={clients}
                        keyFn={keyForClient}
                        item={<EstateClientRow />}
                        fallback={<NoEstateResults columns={8} />}
                    />
                </TableBody>
            </Table>
        </TableContainer>
    )

    function keyForClient(client) {
        return client.configId || client.clientId
    }
}
